<template>
  <div v-ga-section-view class="media-platforms" data-section-number="99" data-section-name="Footer">
    <ul class="box">
      <!-- <li>Join width us!</li> -->
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Facebook',
          }"
          href="//www.facebook.com/maplestory"
          target="_blank"
          ><i-simple-icons-facebook
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Twitter',
          }"
          href="//twitter.com/maplestory"
          target="_blank"
          ><i-simple-icons-x
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Youtube',
          }"
          href="//www.youtube.com/user/MapleStory"
          target="_blank"
          ><i-simple-icons-youtube
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Instagram',
          }"
          href="//www.instagram.com/maplestory/"
          target="_blank"
          ><i-simple-icons-instagram
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Twitch',
          }"
          href="//www.twitch.tv/maplestory"
          target="_blank"
          ><i-simple-icons-twitch
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Discord',
          }"
          href="//discord.gg/maplestory"
          target="_blank"
          ><i-simple-icons-discord
        /></a>
      </li>
      <li>
        <a
          v-ga-event="{
            interaction: 'link_click',
            sectionContent: 'Tiktok',
          }"
          href="//www.tiktok.com/@maplestory"
          target="_blank"
          ><i-simple-icons-tiktok
        /></a>
      </li>
    </ul>
  </div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
  .media-platforms {
    position: relative;
    background: #191a1c;
    z-index: 2;
    .box {
      display: table;
      margin: 0 auto;
      list-style-type: none;
      border-radius: 50px;
      color: white;
      text-align: center;
      padding: 34px 0 0;
      a {
        text-decoration: none;
        color: inherit;
      }
      li {
        display: table-cell;
        vertical-align: middle;
        // text-transform: uppercase;
        // font-size: 1.5vw;
        // font-weight: 700;
        display: inline-block;
        padding: 0 16px 10px;
        svg {
          width: 25px;
          height: 100%;
          vertical-align: middle;
          transition: color 0.2s;
          cursor: pointer;
          &:hover {
            color: #c23e31;
          }
        }
      }
    }
  }
  @media only screen and (max-width: 450px) {
    .media-platforms {
      .box {
        li {
          padding: 0 12px 10px;
          svg {
            width: 24px;
          }
        }
      }
    }
  }
</style>
